<template>
  <div>
    <i-select :value="id" :filterable="true" :clearable="clearable" @input="input" class="select-instance" :disabled="disabled">
      <i-option v-for="(item, key) in instance" :key="key" :label="item[0].name" :disabled="item[1].disabled" :value="item[2].id+item[1].disabled" />
    </i-select>
  </div>
</template>
<script>
  import { InstanceService } from '@autocaller_v2/services/InstanceService';

  export default {
    props: {
      id: {
        type: [String, Number],
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
    },
    data: () => ({
      region: [],
      choosed: false
    }),
    created() {
      InstanceService.getList().then(data => {
        this.region = data || [];
      });
    },
    computed: {
      instance() {
        let items = [];
        this.region.forEach(function(reg) {
          items.push([{name: reg.name}, {disabled: true }, {id: reg.id}]);
          reg.instances.forEach(function(ins) {
            items.push([{name: ins.caption}, {disabled: false}, {id: ins.id}])
          })
        })
        return items;
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
